import React from "react";

// ASSETS

// STYLES
import {
  CardAtomContainer,
  CardAtomIcon,
  CardAtomIconWrapper,
  CardAtomTextWrapper,
  CardAtomWrapper,
} from "./CardAtomStyled";

// LIBRARIES

// MISC
import { IProps, CardType } from "./CardAtomModel";
import { TextType } from "../CustomText/CustomTextModel";
import { COLORS } from "constants/variables";

// REDUX

// COMPONENTS
import CustomText from "../CustomText/CustomText";

const CardAtom = (props: IProps) => {
  // PROPERTIES
  const { text = "", type = CardType.REDIRECT, href = "", icon = "" } = props;

  // LIBRARY CONSTANTS

  // STATE CONSTANTS

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS

  return (
    <CardAtomContainer
      href={href}
      target={href.endsWith(".pdf") ? "_blank" : "_self"}
    >
      <CardAtomWrapper type={type}>
        <CardAtomTextWrapper>
          <CustomText
            text={text}
            type={TextType.H3}
            color={
              type === CardType.CONTACT ? COLORS.RaisinBlack : COLORS.Cultured
            }
          />
        </CardAtomTextWrapper>
        <CardAtomIconWrapper>
          <CardAtomIcon src={icon} type={type} />
        </CardAtomIconWrapper>
      </CardAtomWrapper>
    </CardAtomContainer>
  );
};

export default CardAtom;
